import { getCompleteSitesOptions } from '@/helpers/constants'
import { isNumber } from 'lodash'

function getRandomInt({ max, omit }) {
  omit = [omit].flat()
  const res = Math.floor(Math.random() * (max + 1))
  if (omit.includes(res) || res > max) {
    return getRandomInt({ max, omit })
  }
  return res
}

function sortByPosition(positionA, positionB) {
  const positions = ['OOP', 'OOP+1', 'IP']
  const aIdx = positions.indexOf(positionA)
  const bIdx = positions.indexOf(positionB)
  return aIdx - bIdx
}

function getRandomOption({ options, selected }) {
  if (!options.length) {
    return null
  }
  const idx = options.findIndex(i => i === selected)
  const pos = getRandomInt({ max: options.length - 1, omit: idx })
  return options[pos]
}

function getRandomOptions({ options, selected }) {
  if (!options.length) {
    return null
  }
  if (selected.length) {
    options = options.filter(i => !selected.includes(i))
  }
  const pos = getRandomInt({ max: options.length - 1 })
  return options[pos]
}

function getMaxValue({ arr, key }) {
  if (key) {
    arr = arr.map(i => i[key])
  }
  const res = Math.max(...arr)
  return res
}
function getMinValue({ arr, key }) {
  if (key) {
    arr = arr.map(i => i[key])
  }
  const res = Math.min(...arr)
  return res
}
function getScaledValue({ min, max, value }) {
  if (min === max && value === max) {
    return value
  }
  const scale100 = max - min
  let res = value - min
  res = res < 0 ? 0 : res > scale100 ? scale100 : res
  const scaledValue = res / (scale100 || 1)
  return scaledValue
}
// console.log({ min, max, value, scaledValue })

// function getScaledByMax({  max, value }) {
//   const percent = value / max
//   const res = value * percent
//   return res
// }

function getPercentageOfMax({ max, value }) {
  const res = value / (max || 1)
  return res
}

function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null
}

function getUniqueKeys({ arr, key, keys }) {
  let res = arr.map(i => i[key])
  res = [...new Set(res)]
  return res
}

// function getUniqueKeysByKeys({ arr, keys }) {
//   let res = arr.map(i => i[keys.find(k => k in i)])
//   res = [...new Set(res)]
//   return res
// }

function getUniqueArr({ arr, key }) {
  const res = [...new Map(arr.map(item => [item[key], item])).values()]
  return res
}

function toggleArrByKey({ arr, item, items, key = 'name', addToStart, singleItem }) {
  if (items) {
    const included = arr.some(a => items.some(r => a[key] === r[key]))
    const emptied = arr.filter(a => !items.some(r => a[key] === r[key]))
    if (included) {
      return emptied
    }
    if (addToStart) {
      return [...items, ...emptied]
    }
    return [...emptied, ...items]
  }
  if (arr.some(c => c[key] === item[key])) {
    const res = arr.filter(c => c[key] !== item[key])
    if (singleItem) {
      return [res[0]].filter(i => i)
    }
    return res
  }
  if (singleItem) {
    return [item]
  }
  if (addToStart) {
    return [item, ...arr]
  }
  return [...arr, item]
}

function toggleArr({ arr, item, items, addToStart }) {
  if (items) {
    const included = arr.some(a => items.some(r => a === r))
    const emptied = arr.filter(a => !items.some(r => a === r))
    if (included) {
      return emptied
    }
    if (addToStart) {
      return [...items, ...emptied]
    }
    return [...emptied, ...items]
  }
  if (arr.includes(item)) {
    return arr.filter(c => c !== item)
  }
  if (addToStart) {
    return [item, ...arr]
  }
  return [...arr, item]
}

function numRoundTo5bb(num) {
  if (typeof num === 'number') {
    return num - Math.trunc(num) === 0.75 ? Math.trunc(num) : Math.round(num * 2) / 2
  }
  return ''
}

function numRound(val, num = 0) {
  return Number(val.toFixed(num))
}

function numFixed(val, num = 0) {
  if (val === null || val === undefined) {
    return ''
  }
  if (isNumber(val) && !isNaN(val)) {
    return numRound(val, num)
  }
  return ''
}

function SNK(key, namespace) {
  return `${namespace ? `${namespace}/` : ''}${key}`
}

function getCubicBezier4pointPath({ boundaryEl, startEl, controlStartEl, endEl, controlEndEl }) {
  const boundary = boundaryEl.getBoundingClientRect()

  const start = startEl.getBoundingClientRect()
  const end = endEl.getBoundingClientRect()
  const controlStart = controlStartEl ? controlStartEl.getBoundingClientRect() : null
  const controlEnd = controlEndEl ? controlEndEl.getBoundingClientRect() : null

  const bLeft = boundary.left
  const bTop = boundary.top
  const bWidth = boundary.width
  const bHeight = boundary.height

  const startX = (start.left - bLeft) / bWidth
  const startY = (start.top - bTop) / bHeight

  const start_control_X = controlStart ? (controlStart.left - bLeft) / bWidth : 1 - startX
  const start_control_Y = controlStart ? (bTop - controlStart.top) / bHeight : startY

  const endX = (end.left - bLeft) / bWidth
  const endY = (end.top - bTop) / bHeight

  const end_control_X = controlEnd ? (controlEnd.left - bLeft) / bWidth : 1 - endX
  const end_control_Y = controlEnd ? (controlEnd.top - bTop) / bHeight : endY

  // let p0 = { x: 0, y: 1 }  // The first point on curve
  // let c0 = { x: 0.5, y: 1 }   // Controller for p0
  // let c1 = { x: 0.5, y: 0 } // Controller for p1
  // let p1 = { x: 1, y: 0 }  // The last point on curve

  const p0 = { x: startX, y: startY } // The first point on curve
  const c0 = { x: start_control_X, y: start_control_Y } // Controller for p0
  const c1 = { x: end_control_X, y: end_control_Y } // Controller for p1
  const p1 = { x: endX, y: endY } // The last point on curve

  const path = `M ${p0.x} ${p0.y} C ${c0.x} ${c0.y} ${c1.x} ${c1.y} ${p1.x} ${p1.y}`

  // `<path
  // id="path"
  // class="draw"
  // style="stroke: red"
  // d="M 0 1C 0.5 1, 0.5 0, 1 0"
  // fill="transparent"
  // vector-effect="non-scaling-stroke"
  // ></path> `

  return path
}

// from shepherd.js
function getOverlayPath({ width, height, x = 0, y = 0, r = 0 }) {
  const { innerWidth: w, innerHeight: h } = window
  return `M${w},${h}\
H0\
V0\
H${w}\
V${h}\
Z\
M${x + r},${y}\
a${r},${r},0,0,0-${r},${r}\
V${height + y - r}\
a${r},${r},0,0,0,${r},${r}\
H${width + x - r}\
a${r},${r},0,0,0,${r}-${r}\
V${y + r}\
a${r},${r},0,0,0-${r}-${r}\
Z`
}

function balanceValues(arrNum, aIdx, min = 0, max = 1, total = 1) {
  const nextIdx = aIdx + 1 > arrNum.length - 1 ? 0 : aIdx + 1
  let l_total = arrNum.reduce((acc, i) => acc + i, 0)
  const balance = total - l_total
  let res = arrNum.map((i, idx) => {
    if (idx === aIdx) {
      return i
    }
    if (idx === nextIdx) {
      const str = i + balance
      if (str <= max && str >= min) {
        i = str
      }
      if (str < min) {
        i = 0
      }
      return i
    }
    return i
  })
  l_total = res.reduce((acc, i) => acc + i, 0)
  if (l_total !== total) {
    return balanceValues(res, nextIdx)
  }

  res = res.map(i => {
    // https://stackoverflow.com/questions/21690070/javascript-float-comparison
    let num = Number(i.toFixed(10))
    num = num > max ? max : num < min ? min : num
    return num
  })

  return res
}

function getByStrPath({ obj, strPath }) {
  const res = strPath.split('.').reduce((acc, k) => acc && acc[k], obj)
  return res
}

function getSiteItem(siteId) {
  return getCompleteSitesOptions().find(i =>
    [...(i.aliases || []), i.id].some(id => siteId?.toLowerCase().includes(id.toLowerCase())),
  )
}

export {
  SNK,
  getMinValue,
  getMaxValue,
  getRandomInt,
  getRandomOption,
  getRandomOptions,
  getScaledValue,
  sleep,
  // getScaledByMax,
  getPercentageOfMax,
  hexToRgb,
  getUniqueKeys,
  // getUniqueKeysByKeys,
  getUniqueArr,
  toggleArrByKey,
  toggleArr,
  numRoundTo5bb,
  numFixed,
  numRound,
  getCubicBezier4pointPath,
  getOverlayPath,
  balanceValues,
  getByStrPath,
  getSiteItem,
  sortByPosition,
}
